module.exports = __webpack_public_path__ + "img/sec2_1_.70d990c6.png";